import React from 'react';
import { Modal, Button } from 'react-bootstrap';

interface PopupProps {
  title?: string;
  show: boolean;
  isSaymee: boolean;
  handleVisible: () => void;
}

export default function GuidePopup({
  show,
  title,
  isSaymee,
  handleVisible,
}: PopupProps): JSX.Element {
  return (
    <>
      <Modal
        show={show}
        size="lg"
        onHide={() => handleVisible()}
        dialogClassName="modal-90w modal-landing customer-button-close"
        aria-labelledby="example-custom-modal-styling-title"
        centered
      >
        <Modal.Header>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="text-truncate d-flex justify-content-center guide-note"
          >
            <p className="title-header mb-0 text-truncate text-header px-3">{title}</p>
            <Button variant="" className="bt-close-modal" onClick={handleVisible}></Button>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="px-3 guide-note">
            {isSaymee ? (
              <p className="pb-1">
                1. Đối với thuê bao Saymee: Truy cập vào trang web:{' '}
                <a href="https://chiase.mobifone.vn/saymee">https://chiase.mobifone.vn/saymee</a>{' '}
                theo đường dẫn nhận được từ tin nhắn SMS .
              </p>
            ) : (
              <>
                <p className="pb-1">
                  1. Khách hàng tham gia:
                  {/* <a href="https://chiase.mobifone.vn">https://chiase.mobifone.vn</a> theo đường dẫn
                nhận được từ tin nhắn SMS. */}
                </p>
                <p className="ps-3">
                  - Thuê bao MobiFone phát sinh tương tác trên các kênh sau được tham gia chương
                  trình: Ứng dụng My MobiFone, Chatbot hỗ trợ khách hàng, Tổng đài hỗ trợ khách hàng
                  (Tổng đài), Hệ thống cửa hàng (Cửa hàng) và nhận được tin nhắn mời tham gia từ
                  MobiFone. <b>Loại trừ:</b>{' '}
                  <i>
                    thuê bao liên lạc nghiệp vụ, thuê bao BCA, VCA, FastConnect, M2M, MVNO, thuê bao
                    thuộc chính sách khách hàng đặc biệt.
                  </i>
                </p>
                <p className="ps-3">- Tương tác hợp lệ trên từng kênh được xác định như sau:</p>
                <p className="ps-5">
                  • Kênh App My MobiFone: thực hiện các giao dịch Thanh toán/nạp tiền, Mua gói cước,
                  Đổi điểm Kết Nối Dài Lâu.
                </p>
                <p className="ps-5">
                  • Kênh Tổng đài: Khách hàng gọi lên Tổng đài hỗ trợ khách hàng của MobiFone, kết
                  nối tới Điện thoại viên và có thời gian đàm thoại trên 30 giây.
                </p>
                <p className="ps-5">
                  • Kênh Cửa hàng: Khách hàng MobiFone được ghi nhận phát sinh giao dịch hoặc được
                  hỗ trợ tại các cửa hàng MobiFone trên toàn quốc và nhận được tin nhắn mời tham gia
                  từ MobiFone.
                </p>
                <p className="ps-3">
                  - Sau khi khách hàng phát sinh tương tác hợp lệ theo các tiêu chí trên, hệ thống
                  sẽ gửi lời mời tham gia khảo sát như sau:
                </p>
                <p className="ps-5">
                  • Kênh App My MobiFone: hiển thị popup và gửi push notification.
                </p>
                <p className="ps-5">• Kênh Cửa hàng và kênh Tổng đài: gửi tin nhắn SMS.</p>
                <p className="ps-3 pb-1">
                  - Khách hàng truy cập đường link được gửi theo một trong các phương thức nêu trên
                  để bắt đầu tham gia chương trình.
                </p>
              </>
            )}

            <p className="pb-1">
              2. Bắt đầu và nhập số điện thoại nhận được tin nhắn mời tham gia chương trình.
              {/* của{' '}{isSaymee ? 'Saymee' : 'MobiFone'}. */}
            </p>
            {/* <p className="pb-1">
              Lưu ý: chương trình chỉ áp dụng cho thuê bao {isSaymee ? 'Saymee' : 'MobiFone'} đủ
              điều kiện tham gia chương trình.
            </p> */}

            <p className="pb-1">3. Hoàn thành khảo sát và lấy mã quay thưởng.</p>
            <p className="pb-1">4. Nhập mã quay thưởng và tiến hành quay thưởng.</p>
            <p className="pb-1">
              5. Đối với khách hàng trúng thưởng: MobiFone sẽ liên hệ và tiến hành trao thưởng tùy
              theo địa chỉ lưu trú.
            </p>
          </div>
        </Modal.Body>

        <Modal.Footer className="d-flex flex-column px-5 pb-4">
          <Button variant="danger fs-18 rounded-pill text-bold" onClick={() => handleVisible()}>
            Đóng lại
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
